import Vue from 'vue'
import App from './App.vue'
import router from './router'

import store from './store'

Vue.config.productionTip = false

const data = {
  token: null,
  count: 0,
}

new Vue({
  data,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
